import _extends from '@babel/runtime-corejs3/helpers/extends';
import React__default from 'react';
import { Trigger } from '@radix-ui/react-dropdown-menu';
import classNames from 'classnames';
import '../../icons/index.es.js';
import styles from './Menu2.js';
import '../../utils/index.js';
import { useMenuContext } from './MenuContext.js';
import { DATA_TESTID_SUFFIXES as DATA_TESTID_SUFFIXES$1 } from './constants.js';
import '../../hooks/index.js';
import '../../components/index.js';
import { DATA_TESTID_SUFFIXES } from '../Select/constants.js';
import useSelectContext from '../Select/SelectContext.js';
import Tooltip from '../../components/Tooltip/Tooltip.js';
import useIsTruncated from '../../hooks/useIsTruncated/useIsTruncated.js';
import mergeRefs from '../../utils/mergeRefs/mergeRefs.js';
import getSubDataTestId from '../../utils/getSubDataTestId/getSubDataTestId.js';
import ChevronDownIcon from '../../icons/components/ChevronDownIcon.js';

const AsChildWrapper = _ref => {
  let {
    asChild,
    isTruncated,
    tooltipContent,
    children
  } = _ref;
  return asChild ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, children) : /*#__PURE__*/React__default.createElement(Tooltip, {
    disabled: !isTruncated || !['string', 'number'].includes(typeof tooltipContent),
    content: tooltipContent,
    delayMs: 250
  }, /*#__PURE__*/React__default.createElement("div", {
    className: styles.buttonContainer
  }, children));
};
const MenuButton = /*#__PURE__*/React__default.forwardRef((_ref2, ref) => {
  let {
    asChild,
    children,
    className,
    ...rest
  } = _ref2;
  const {
    dataTestId: rootDataTestId,
    isDisabled,
    triggerRef
  } = useMenuContext();
  const isTruncated = useIsTruncated(triggerRef);
  const withinSelect = useSelectContext(true) !== null;
  return /*#__PURE__*/React__default.createElement(AsChildWrapper, {
    asChild: asChild,
    tooltipContent: children,
    isTruncated: isTruncated
  }, /*#__PURE__*/React__default.createElement(Trigger, _extends({}, rest, {
    "aria-disabled": isDisabled,
    className: classNames(className, {
      [styles.button]: !asChild
    }),
    asChild: asChild,
    ref: mergeRefs(triggerRef, ref),
    "data-testid": getSubDataTestId(rootDataTestId, withinSelect ? DATA_TESTID_SUFFIXES.SELECT_BUTTON : DATA_TESTID_SUFFIXES$1.MENU_BUTTON)
  }), children), !asChild && /*#__PURE__*/React__default.createElement(ChevronDownIcon, {
    className: styles.rightIcon,
    "aria-hidden": "true"
  }));
});

export { MenuButton as default };
